import { useReducer } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

import { MAX_COMPANY_LEN, MAX_EMAIL_LEN, MAX_MESSAGE_LEN, MAX_NAME_LEN, MAX_PHONE_LEN } from '../../../core/constants/forms';
import { ROUTES } from '../../../core/constants/navigation';
import { SERVICES } from '../../../core/constants/services';
import { site } from '../../../global/config/site';
import Button from '../../../common/components/Button/Button';
import { IconSend } from '../../../common/icons';
import { buildContactMailto } from '../utils/mailto';

import '../styles/contact-form.css';

const OTHER_SERVICE = 'otro';

function fieldReducer(state, { name, value }) {
    return { ...state, [name]: value };
}

export default function ContactForm({ initialService = '' }) {
    const [values, setField] = useReducer(fieldReducer, {
        name: '',
        email: '',
        phone: '',
        company: '',
        service: initialService,
        message: '',
        hasConsent: false,
    });

    const handleChange = (event) => {
        const { name, type, checked, value } = event.target;
        setField({ name, value: type === 'checkbox' ? checked : value });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const service = SERVICES.find(item => item.id === values.service);
        window.location.href = buildContactMailto({
            to: site.contactEmail,
            values,
            serviceLabel: service ? service.title : 'Otro / aún no lo sé',
        });
        toast.success('Abrimos tu correo con la solicitud lista para enviar.');
    };

    return (
        <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-form__grid">
                <label className="contact-form__field">
                    <span className="contact-form__label">Nombre completo <span aria-hidden="true">*</span></span>
                    <input className="contact-form__input" name="name" type="text" autoComplete="name"
                        required maxLength={MAX_NAME_LEN} value={values.name} onChange={handleChange} />
                </label>

                <label className="contact-form__field">
                    <span className="contact-form__label">Correo electrónico <span aria-hidden="true">*</span></span>
                    <input className="contact-form__input" name="email" type="email" autoComplete="email"
                        required maxLength={MAX_EMAIL_LEN} value={values.email} onChange={handleChange} />
                </label>

                <label className="contact-form__field">
                    <span className="contact-form__label">Teléfono o WhatsApp</span>
                    <input className="contact-form__input" name="phone" type="tel" autoComplete="tel"
                        maxLength={MAX_PHONE_LEN} value={values.phone} onChange={handleChange} />
                </label>

                <label className="contact-form__field">
                    <span className="contact-form__label">Medio o empresa</span>
                    <input className="contact-form__input" name="company" type="text" autoComplete="organization"
                        maxLength={MAX_COMPANY_LEN} value={values.company} onChange={handleChange} />
                </label>

                <label className="contact-form__field contact-form__field--wide">
                    <span className="contact-form__label">Servicio de interés <span aria-hidden="true">*</span></span>
                    <select className="contact-form__input contact-form__select" name="service"
                        required value={values.service} onChange={handleChange}>
                        <option value="" disabled>Selecciona una opción</option>
                        {SERVICES.map(service => (
                            <option key={service.id} value={service.id}>{service.title}</option>
                        ))}
                        <option value={OTHER_SERVICE}>Otro / aún no lo sé</option>
                    </select>
                </label>

                <label className="contact-form__field contact-form__field--wide">
                    <span className="contact-form__label">Cuéntanos sobre tu proyecto <span aria-hidden="true">*</span></span>
                    <textarea className="contact-form__input contact-form__textarea" name="message" rows={5}
                        required maxLength={MAX_MESSAGE_LEN} value={values.message} onChange={handleChange}
                        placeholder="¿Qué quieres lograr? ¿Tienes fechas o referencias?" />
                </label>
            </div>

            <label className="contact-form__consent">
                <input className="contact-form__checkbox" name="hasConsent" type="checkbox"
                    required checked={values.hasConsent} onChange={handleChange} />
                <span>
                    Autorizo el tratamiento de mis datos personales según la{' '}
                    <Link to={ROUTES.PRIVACY} target="_blank" rel="noopener">política de tratamiento de datos</Link>.
                </span>
            </label>

            <div className="contact-form__footer">
                <Button type="submit" icon={<IconSend />}>Enviar solicitud</Button>
                <p className="contact-form__hint">Se abrirá tu aplicación de correo con el mensaje listo para enviar.</p>
            </div>
        </form>
    );
}
